import { shellApi } from "../../api/api";
import { QuickActionItem } from "../shared-components/quick-action-item/quick-action-item";
import { navigateToEcap } from "../../features/navigate-to-ecap/navigate-to-ecap";

export const registerDoctorQuickActionViews = () => {
  shellApi.regionManager.registerView(shellApi.regionManager.regions.shell.quickActions, {
    id: "dates",
    sortHint: "0011",
    factory: () => {
      const quickActionItem = new QuickActionItem("", "Cita", () => {
        navigateToEcap("CREAR_VISITA");
      });
      return Promise.resolve(quickActionItem);
    },
  });
};
